const helpCenterUrl =
  'https://sites.google.com/view/faqsomastore/menu?authuser=0';

export { helpCenterUrl };
